module.exports = {"name":"iframe","version":"0.1.191","private":true,"scripts":{"start-js":"react-scripts start","watch-css":"stylus src/css/Iframe.styl -o src/css -w","start":"npm-run-all -p start-js watch-css","build":"react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject"}}


//////////////////
// WEBPACK FOOTER
// ./src/iframe/package.json
// module id = 55
// module chunks = 0